// extracted by mini-css-extract-plugin
module.exports = {"offersSection":"offers_offersSection__2_rPc"};